import ACCOUNT_CLIENT_API_ENDPOINTS from '@api/endpoints';
import HTTP_METHODS_ENUM from '@api/enums/HTTP_METHODS_ENUM.enum';
import configRequest from '@api/requests/configRequest';

import { showToast } from '@app/providers/ToastProvider';

export interface SendVerificationEmailCodeData {
	contact: string;
	type: string;
	branch: number;
}

const sendVerificationEmailCode = configRequest<null, SendVerificationEmailCodeData>({
	requestPrefix: 'auth/sendVerificationEmailCode',
	reqConfigCreator: data => ({
		url: ACCOUNT_CLIENT_API_ENDPOINTS.AUTH.VERIFICATION.EMAIL.SEND(),
		method: HTTP_METHODS_ENUM.POST,
		data,
	}),
	onSuccess: () => showToast.success('The code has been sent to your email.'),
});

export default sendVerificationEmailCode;
